import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { EXPORT_USER_OBJECTS_QUERY } from '../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../Spinner/Spinner.js'
import { getData } from '../CustomCode/CustomUtils'

const EXPORT_USER_OBJECTS = gql(EXPORT_USER_OBJECTS_QUERY)

export default function ExportUserObjects() {
  console.log('ExportUserObjects rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(null, EXPORT_USER_OBJECTS, 'exportUserObjects', setResults, setGraphQLErrors)
  }, [])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let html = ''
    for (let objectType of results) {
      html += objectType.sql
    }
    return (
      <div style={{ height: '100%', overflow: 'auto',  padding: '10px' }}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    )
  }
}
